export default class publishPageScheduler {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/event/directives/publish-page-scheduler.html'),
            controller: PageScheduler,
            controllerAs: 'scheduler'
        }
    }
}

class PageScheduler {
    constructor($scope, $filter, $stateParams, Event, SweetAlert, Events) {
        this._translator = $filter('translate');
        this._scope = $scope;

        this.eventHandler = Events;
        this.alerter = SweetAlert;
        this.eventRepo = Event;

        this.schedulerType = 'draft'; // default.
        this.minimumDate = moment().format('YYYY-MM-DD');
        this.type = $stateParams.type;
        this.isVisible = false;

        this.scheduler = {
            date: moment().format('YYYY-MM-DD'),
            time: {
                hour: '08',
                minutes: '00'
            },
            relativeDate: false
        };

        this._scope.$on('event:page:showScheduler', (event, data) => {
            this.event = data['event'];
            if (data['type']) {
                this.type = data['type'];
            }
            this.isVisible = true;

            this.eventRepo.find(this.event.id).then((event) => {
                if (event.data.pages[this.type] && event.data.pages[this.type].data) {
                    let eventPageData = angular.fromJson(event.data.pages[this.type].data);
                    this.publishAt = moment(eventPageData['metadata']['publish_at']);
                    this.isScheduled = (moment() < this.publishAt && event.data.pages.episubscription.status);
                    this.scheduler.date = moment(this.publishAt).format('YYYY-MM-DD');
                    this.scheduler.time = {
                        hour: moment(this.publishAt).format('HH'),
                        minutes: moment(this.publishAt).format('mm')
                    };
                }
            });

            angular.forEach(this.event.campaigns, (campaign) => {
                if (campaign.pivot.event_dispatcher_type_id == 1) {
                    this.invitation = campaign;
                }
            });
        });
    }
    
    close() {
        this.isVisible = false;
    }

    onRelativeDateChange() {
        let newDate = this.scheduler.relativeDate;

        if (angular.isNumber(newDate) && newDate >= 0) {
            var date;
            if (this.schedulerType == 'relativeAfter') {
                date = moment(this.event.start_date).add(newDate, 'days');
            } else {
                date = moment(this.event.start_date).subtract(newDate, 'days');
            }

            if (date > moment()) {
                this.scheduler.date = date.format('YYYY-MM-DD');
            }
        } else if (newDate < 0) {
            this.scheduler.relativeDate = 0;
        }
    }

    setSchedulerType(type) {
        this.schedulerType = type;

        if (type == 'relativeBefore' || type == 'relativeAfter') {
            this.scheduler.relativeDate = 1;
        }
    };

    toSchedule() {
        if (this.schedulerType == 'draft') {
            this.close();
            this._scope.$emit('event:page:save', { publishAt: this.scheduler.date });
            return;
        }

        let type = (this.schedulerType == 'relativeBefore' || this.schedulerType == 'relativeAfter') ? 'scheduled' : this.schedulerType;

        if (type == 'scheduled' && this.type != 'episurvey' && (moment(this.scheduler.date) > moment(this.event.start_date))) {
            return this.eventHandler.flashEvent('error', this._translator('EVENT:SCHEDULER:SCHEDULE_AFTER_EVENT'));
        }

        if (type == 'scheduled' && this.type == 'episurvey' && (moment(this.scheduler.date) < moment(this.event.start_date))) {
            return this.eventHandler.flashEvent('error', this._translator('EVENT:FLASH:SURVEY_INCORRECT_TIME'));
        }

        var formattedDate;
        
        if (type == 'scheduled') {
            formattedDate = moment(this.scheduler.date);
            formattedDate.set({ hour: this.scheduler.time.hour, minute: this.scheduler.time.minutes });
        } else if (type == 'now') {
            formattedDate = moment().subtract(1, 'hours'); // Fix for async clocks.
        }

        if (this.type == 'episubscription'
            && (! this.invitation
                || ! this.invitation.schedule
                || moment(this.invitation.schedule.date) > formattedDate
                || this.invitation.campaign_status_id != 4
            )
        ) {
            this._scope.$emit('event:page:publish', { publishAt: formattedDate });
        } else if (this.type !== 'episurvey') {
            this.alerter.swal({
                title: this._translator('EVENT:FLASH:SCHEDULE_ERROR'),
                text: this._translator('EVENT:FLASH:PAGE_AFTER_INVITATION_BODY'),
                type: 'error'
            });
        } else {
            this._scope.$emit('event:page:publish', { publishAt: formattedDate });
        }
        this.close();
    };
}